import {
  ChipField,
  Datagrid,
  DateField,
  EditButton,
  List,
  ListProps,
  SelectInput,
  ShowButton,
  TextField,
  TextInput,
  useRecordContext,
  FieldProps,
} from "react-admin";
import { StandardPagination } from "../../common/StandardPagination";

interface UserRecord {
  role: string;
}

const RoleField = (props: FieldProps) => {
  const record = useRecordContext<UserRecord>(props);
  if (!record) return null;
  
  const roleName = record.role === "ADMIN" ? "Administrador" : "Usuario";
  return <ChipField record={{ name: roleName }} source="name" />;
};

export const ListUsers: React.FC<ListProps> = (props) => {
  const filters = [
    <TextInput key="email" label="Email" source="email" alwaysOn />,
    <TextInput
      key="fullName"
      label="Nombre completo"
      source="fullName"
      alwaysOn
    />,
    <SelectInput
      key="role"
      label="Rol"
      source="role"
      alwaysOn
      choices={[
        { id: "ADMIN", name: "Administrador" },
        { id: "APPLICANT", name: "Usuario" },
      ]}
    />,
    <SelectInput
      key="language"
      label="Idioma"
      source="language"
      choices={[
        { id: "Español", name: "Español" },
        { id: "Inglés", name: "Inglés" },
        { id: "Portugués", name: "Portugués" },
        { id: "Francés", name: "Francés" },
        { id: "Alemán", name: "Alemán" },
        { id: "Italiano", name: "Italiano" },
        { id: "Chino", name: "Chino" },
        { id: "Japonés", name: "Japonés" },
        { id: "Ruso", name: "Ruso" },
        { id: "Árabe", name: "Árabe" },
        { id: "Otro", name: "Otro" },
      ]}
    />,
    <SelectInput
      key="languageLevel"
      label="Nivel de Idioma"
      source="languageLevel"
      choices={[
        { id: "Básico", name: "Básico" },
        { id: "Intermedio", name: "Intermedio" },
        { id: "Avanzado", name: "Avanzado" },
      ]}
    />,
    <TextInput key="phone" label="Teléfono" source="phone" />,
    <TextInput key="address1" label="Dirección 1" source="address1" />,
    <TextInput key="address2" label="Dirección 2" source="address2" />,
    <TextInput key="maxAge" label="Edad Máxima" source="maxAge" />,
    <TextInput key="minAge" label="Edad Mínima" source="minAge" />,
    <TextInput key="skillName" label="Habilidad" source="skillName" />,
  ];

  return (
    <List
      {...props}
      perPage={10}
      filters={filters}
      pagination={<StandardPagination />}
      sort={{ field: "createdAt", order: "DESC" }}
    >
      <Datagrid optimized>
        <TextField source="email" label="Email" />
        <TextField source="fullName" label="Nombre completo" />
        <RoleField label="Rol" />
        <DateField source="createdAt" label="Fecha de Registro" />
        <ShowButton label="Ver" />
        <EditButton label="Editar" />
      </Datagrid>
    </List>
  );
};
